export enum MarketingPageType {
	Series = "series",
	Sermons = "sermons",
}
